import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Persona} from '../../../../../chacra-core';

export {Persona} from '../../../../../chacra-core';

export const personasAdapter: EntityAdapter<Persona> = createEntityAdapter<Persona>({
  selectId: model => model.personaId,
  sortComparer: (a: Persona, b: Persona): number =>
    b.personaId.localeCompare(a.personaId)
});

export interface PersonasState extends EntityState<Persona> {
  isLoading?: boolean;
  error?: string | null;
}

export const initialState: PersonasState = personasAdapter.getInitialState(
  {
    isLoading: false,
    error: null
  }
);
